import { IUser } from '../../models/i-user';
import {
  LOAD_USER,
  LOAD_USER_FAIL,
  LOAD_USER_SUCCESS,
  UPDATE_USER_INFO,
  LOG_USER_OUT,
  UPDATE_USER_INVOICE_INFO,

  LoadUserSuccess,
  UpdateUserInvoiceInfo,
  UserAction,
} from '../user.actions';


export interface UserState {
  user: IUser;
  loaded: boolean;
  loading: boolean;
  error?: boolean;
}

export const initialState: UserState = {
  user: null,
  loaded: false,
  loading: false,
};

export function userReducer(
  state = initialState,
  action: UserAction
): UserState {
  switch (action.type) {
    case LOAD_USER: {
      return {
        ...state,
        loading: true,
      };
    }

    case UPDATE_USER_INVOICE_INFO: {
      return {
        ...state,
        user: {
          ...state.user,
          invoiceInfo: (action as UpdateUserInvoiceInfo).payload
        }
      };
    }

    case LOAD_USER_SUCCESS: {
      return {
        user: (action as LoadUserSuccess).payload,
        loading: false,
        loaded: true
      };
    }

    case UPDATE_USER_INFO: {
      return {
        user: { invoiceInfo: state.user.invoiceInfo, ...(action as LoadUserSuccess).payload },
        loading: false,
        loaded: true
      };
    }

    case LOAD_USER_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: true
      };
    }

    case LOG_USER_OUT: {
      return {
        user: null,
        loading: false,
        loaded: true,
        error: true
      };
    }

    default:
      return state;
  }
}
